/**
 * Đọc số nguyên dương (VND) ra chữ tiếng Việt, kết thúc bằng "đồng".
 * @param {number} number
 * @returns {string}
 */
export const numberToVietnameseText = (number) => {
  if (number == null || Number.isNaN(number) || number <= 0) return "";

  const n = Math.floor(Math.abs(Number(number)));
  if (n === 0) return "";

  const units = ["", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const scales = ["", "nghìn", "triệu", "tỷ"];

  const readThreeDigits = (num) => {
    const hundred = Math.floor(num / 100);
    const ten = Math.floor((num % 100) / 10);
    const unit = num % 10;
    let result = "";

    if (hundred > 0) result += units[hundred] + " trăm ";

    if (ten > 1) {
      result += units[ten] + " mươi ";
      if (unit === 1) result += "mốt ";
      else if (unit === 5) result += "lăm ";
      else if (unit > 0) result += units[unit] + " ";
    } else if (ten === 1) {
      result += "mười ";
      if (unit === 5) result += "lăm ";
      else if (unit > 0) result += units[unit] + " ";
    } else if (unit > 0) {
      if (hundred > 0) result += "lẻ ";
      result += units[unit] + " ";
    }

    return result.trim();
  };

  let numStr = String(n);
  const chunks = [];
  while (numStr.length > 0) {
    chunks.unshift(parseInt(numStr.slice(-3), 10));
    numStr = numStr.slice(0, -3);
  }

  let result = "";
  chunks.forEach((chunk, index) => {
    if (chunk > 0) {
      result +=
        readThreeDigits(chunk) + " " + scales[chunks.length - 1 - index] + " ";
    }
  });

  return result.trim() + " đồng";
};
